/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCloudDollar = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M14.9 4a4.974 4.974 0 0 0-4.643 3.194A4.84 4.84 0 0 0 8.9 7a5 5 0 0 0-5 5v.491c-1.466 1.157-2.207 2.717-2.583 3.972a10.324 10.324 0 0 0-.41 2.31 5.843 5.843 0 0 0-.007.204V20H6v-2H3.006a8.29 8.29 0 0 1 .227-.963c.337-1.124.986-2.381 2.222-3.205l.445-.297V12a3 3 0 0 1 3-3c.55 0 1.068.16 1.528.436l1.342.804.166-1.556A2.988 2.988 0 0 1 14.9 6a3 3 0 0 1 3 3c0 .005 0 .023-.007.076l-.007.05-.006.044-.015.133-.072.729.674.288A4 4 0 0 1 20.9 14c0 .964-.386 2.005-.994 2.8-.623.813-1.337 1.2-1.906 1.2v2c1.43 0 2.667-.904 3.494-1.985.842-1.101 1.406-2.56 1.406-4.015a5.995 5.995 0 0 0-3.004-5.198A5 5 0 0 0 14.9 4z"
        fill="currentcolor"
      />
      <path
        d="M11 13h-.5a2.5 2.5 0 0 0 0 5h.5v1H9v2h2v1h2v-1h.5a2.5 2.5 0 0 0 0-5H13v-1h2v-2h-2v-1h-2v1zm-.5 3a.5.5 0 0 1 0-1h.5v1h-.5zm3 3H13v-1h.5a.5.5 0 0 1 0 1z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgCloudDollar as CloudDollar };
